export default __webpack_public_path__ + "static/media/AS.92bc418b.svg";